import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { DATATEST } from "constants/integration";

const Tile = ({ color, ...props }: SvgIconProps) => {
    return (
        <SvgIcon {...props} data-test={DATATEST.PROFILE.GRID_VIEW_TYPES.TILE}>
            <path d="M6,2H2C1.4,2,1,2.4,1,3v7c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V3C7,2.4,6.6,2,6,2z" />
            <path d="M6,13H2c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-7 C7,13.4,6.6,13,6,13z" />
            <path d="M14,2h-4C9.4,2,9,2.4,9,3v7c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V3 C15,2.4,14.6,2,14,2z" />
            <path d="M14,13h-4c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-7 C15,13.4,14.6,13,14,13z" />
            <path d="M22,2h-4c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V3 C23,2.4,22.6,2,22,2z" />
            <path d="M22,13h-4c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-7 C23,13.4,22.6,13,22,13z" />
        </SvgIcon>
    );
};

export default Tile;
